import MaterialIcon from '@/components/atom/MaterialIcon';

import { DOCTOR_FILTER_OPTIONS, EDoctorFilterType } from '@/models/diagnosis/doctor-filter';
import theme from '@/styles/theme';

interface Props {
  option: (typeof DOCTOR_FILTER_OPTIONS)[0];
  isSelected: boolean;
  canSelectMore: boolean;
  onToggle: (filterType: EDoctorFilterType) => void;
}

const DoctorFilterOptionButton = ({ option, isSelected, canSelectMore, onToggle }: Props) => {
  const isDisabled = !isSelected && !canSelectMore;

  const handleClick = () => {
    if (isDisabled) {
      return;
    }
    onToggle(option.type);
  };

  return (
    <button
      onClick={handleClick}
      disabled={isDisabled}
      className={`flex flex-col gap-[4px] rounded-[12px] border-[1px] border-solid p-[16px] transition-all ${
        isSelected
          ? 'border-primary-600 bg-[#fff9f5]'
          : isDisabled
            ? 'cursor-not-allowed border-gray-100 bg-white opacity-40'
            : 'border-gray-100 bg-white'
      }`}
    >
      <div className='flex w-full flex-col items-start'>
        {option.iconName && <MaterialIcon name={option.iconName} size={24} color={theme.color.primary700} filled />}
        <p className='typography-ui-15sb mt-[4px] text-gray-900 leading-[22px]'>{option.label}</p>
        <p className='typography-ui-13r text-gray-500 leading-[18px]'>{option.description}</p>
      </div>
    </button>
  );
};

export default DoctorFilterOptionButton;
